import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js';
import { api_gateway } from '../../../conexoes/api';
import { setaDropdown } from '../../../utils/alternanciaIcones';
import decryptJWT from '../../../utils/decryptJWT';

export default function SelectDiasBloqueioTemporario(props) {
    const [spinAtivo, setSpinAtivo] = useState(true);
    const [listaDiasBloqueio, setListaDiasBloqueio] = useState([])

    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };

    function handleDiasBloqueio(diasBloqueio){
        props.setDsDiasBloqueio(diasBloqueio)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectDiasBloqueioTemporario(false)
    }

    function renderDiasBloqueio(){
        if(listaDiasBloqueio.length){
            let dias = listaDiasBloqueio.map(function(item, i){
                return (
                    <li key={item}>
                        <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleDiasBloqueio(item.n0_dias)}>
                            <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">{item.n0_dias} dias</span>
                        </div>
                        {listaDiasBloqueio[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                </li>
                )
            })
            
            return dias;
        }else{
            let dias = listaDiasBloqueio.map(function(item){
                return (
                    <li key={item}>
                        <div disabled className="campo-select-opcao campo-select-opcao-1">
                            <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                        </div>
                    </li>
                );
            })
            
            return dias;
        }

    }

    useEffect(() => {

         async function carregarDias(){
            setSpinAtivo(true)

            const resultado = await api_gateway.get("/m1/consultar/bloqueio_temporario_dias_cliente?n0_codigo_cliente="+decryptJWT("codigoClienteErpAntigo"))
            .then(function(resposta){
                return resposta.data;
            })
            .catch(function(erro){
                throw erro.stack;
            })

            if(resultado.status == 200 && resultado.dados.length > 0){
               setListaDiasBloqueio(resultado.dados)
            }
            else
               setListaDiasBloqueio([{n0_dias:120}])
            
            setSpinAtivo(false)
         }
         carregarDias()
        
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectDiasBloqueioTemporario(false)}>
                <div className="fonte-cor-1 label-campo">{props.dsDiasBloqueio}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    {renderDiasBloqueio()}
                </ul>
            </div>
        </Form>
    )
}